import React from "react";
import { NavLink } from 'react-router-dom';

const FullPageMenu = (props) => {
	const { session } = props;

    return  (
	    <div className="fast-nav-wrap" id="fullpage-menu">
	        <ul className="fast-nav">
				<NavLink exact className="fast-nav__item" to="/">
					<span className="fast-nav__link"></span>
				</NavLink>
	            <li className="fast-nav-dots">
	                <span></span>
	                <span></span>
	                <span></span>
	            </li>
				{
					session.isLoggedIn ?
					<NavLink className="fast-nav__item" to="/profile">
						<span className="fast-nav__link"></span>
					</NavLink>
					:
					<span className="fast-nav__item">
						<span className="fast-nav__link"></span>
					</span>
				}
	            <li className="fast-nav-dots">
	                <span></span>
	                <span></span>
	                <span></span>
	            </li>
				{
					session.isLoggedIn ?
					<NavLink className="fast-nav__item" to="/orders">
						<span className="fast-nav__link"></span>
					</NavLink>
					:
					<span className="fast-nav__item">
						<span className="fast-nav__link"></span>
					</span>
				}
	            <li className="fast-nav-dots">
	                <span></span>
	                <span></span>
	                <span></span>
	            </li>
				{
					session.isLoggedIn ?
					<NavLink className="fast-nav__item" to="/makeorder">
						<span className="fast-nav__link"></span>
					</NavLink>
					:
					<span className="fast-nav__item">
						<span className="fast-nav__link"></span>
					</span>
				}
	            <li className="fast-nav-dots">
	                <span></span>
	                <span></span>
	                <span></span>
	            </li>
				<NavLink className="fast-nav__item" to="/signup">
					<span className="fast-nav__link"></span>
				</NavLink>
	            <li className="fast-nav-dots">
	                <span></span>
	                <span></span>
	                <span></span>
	            </li>
				{
					session.isLoggedIn ?
					<NavLink className="fast-nav__item" to="/account">
						<span className="fast-nav__link"></span>
					</NavLink>
					:
					<span className="fast-nav__item">
						<span className="fast-nav__link"></span>
					</span>
				}
	        </ul>
	    </div>
    )
}

export default FullPageMenu


// WEBPACK FOOTER //
// ./src/components/FullPageMenu.js